export default "__VITE_ASSET__4e78f231__"